import {
  checkToken,
  encryptParameters,
  userName,
} from '../actions/authActions';
import { URL_LICENCE } from '../config/config';

/**
 * Hook personalizado para manejar redirecciones con validación de token
 * @returns {Object} - Objeto con funciones handleExternalRedirect y getRedirectUrl
 */
const useLicenceRedirect = () => {
  /**
   * Genera la URL de redirección basada en el segmento de ruta proporcionado
   * @param {string} pathSegment - Segmento de ruta para la redirección
   * @returns {string|null} - URL generada o null si el token no es válido
   */
  const generateRedirectUrl = pathSegment => {
    const tokenInfo = checkToken();
    if (!tokenInfo?.isValid) return null;

    const requestParameters = {
      token: tokenInfo.jwtToken,
      user: userName(tokenInfo.jwtToken),
      parameters: '',
    };

    const encryptedResponse = encryptParameters(requestParameters);
    const segments = [URL_LICENCE, pathSegment, encryptedResponse].filter(
      Boolean
    );
    return segments.join('/');
  };

  /**
   * Maneja la redirección externa abriendo una nueva pestaña
   * @param {string} pathSegment - Segmento de ruta para la redirección
   */
  const handleExternalRedirect = pathSegment => {
    const redirectUrl = generateRedirectUrl(pathSegment);
    if (redirectUrl) {
      window.open(redirectUrl, '_blank');
    }
  };

  /**
   * Obtiene la URL de redirección sin realizar la redirección
   * @param {string} pathSegment - Segmento de ruta para la redirección
   * @returns {string|null} - URL generada o null si el token no es válido
   */
  const getRedirectUrl = pathSegment => {
    return generateRedirectUrl(pathSegment);
  };

  return { handleExternalRedirect, getRedirectUrl };
};

export default useLicenceRedirect;
